import { render, staticRenderFns } from "./tpProdAssociatedBox.vue?vue&type=template&id=6a75f1a3&scoped=true"
import script from "./tpProdAssociatedBox.vue?vue&type=script&lang=js"
export * from "./tpProdAssociatedBox.vue?vue&type=script&lang=js"
import style0 from "./tpProdAssociatedBox.vue?vue&type=style&index=0&id=6a75f1a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75f1a3",
  null
  
)

export default component.exports